/**
 * Service-Worker Registrierung mit aggressivem Update-Handling.
 *
 * Wird von src/index.js einmal beim App-Start aufgerufen.
 * Wir registrieren nur im HTTPS-Kontext (Preview + Prod).
 * Auf localhost:3000 wird auch registriert (Chrome erlaubt SW auf localhost).
 *
 * WICHTIG (Deploy-Safety): Sobald ein neuer SW aktiv wird, wird die Seite
 * **einmalig automatisch neu geladen** – damit User nach einem Deploy
 * garantiert die aktuelle Version sehen, ohne manuellen Hard-Refresh.
 */

export const registerServiceWorker = () => {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  // Dev-Optionale Deaktivierung via ENV-Flag
  if (process.env.REACT_APP_DISABLE_SW === '1') {
    // Falls früher registriert: bestehende SWs abmelden, damit sie nicht
    // weiterhin aus dem alten Cache ausliefern.
    navigator.serviceWorker.getRegistrations().then((regs) =>
      regs.forEach((r) => r.unregister())
    ).catch(() => {});
    return;
  }

  // Automatischer Reload, wenn ein neuer SW die Kontrolle übernimmt.
  // Ein Flag verhindert Endlos-Reload-Schleifen.
  let hasRefreshed = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hasRefreshed) return;
    hasRefreshed = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        // Update-Check bei jedem App-Start erzwingen
        reg.update().catch(() => {});

        // Wenn ein neuer SW verfügbar ist, sofort aktivieren
        reg.addEventListener('updatefound', () => {
          const newSW = reg.installing;
          if (!newSW) return;
          newSW.addEventListener('statechange', () => {
            if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
              // Neuer SW ist installiert und ein alter aktiv → skipWaiting
              // triggert `controllerchange` → Auto-Reload greift oben.
              newSW.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => {
        // Silent fail – App muss auch ohne SW funktionieren
      });
  });
};
